import { render, staticRenderFns } from "./TreeFolderSelector.vue?vue&type=template&id=fc21b042"
import script from "./TreeFolderSelector.vue?vue&type=script&lang=js"
export * from "./TreeFolderSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports